import { AddCircleOutlineIcon, Button, Text } from '@mercai/clever'
import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { CardDocuments } from '@/components'

import {
  getExternalDocuments,
  getInternalDocuments,
} from './tab-documents.constants'

import { ExternalDocumentsDrawer } from './components'

import { SupplyOrderProps } from '@/types'
import { TabDocumentsProps } from './tab-documents.type'

import styles from './tab-documents.module.css'

export const TabDocuments = ({ supplyOrder, isLoading }: TabDocumentsProps) => {
  const { t } = useTranslation('screenSupplyOrderDetail')

  const [isOpenExternalDocuments, setIsOpenExternalDocuments] = useState(false)

  const internalDocuments = getInternalDocuments(t, supplyOrder)
  const externalDocuments = getExternalDocuments(t, supplyOrder)

  return (
    <div className={styles.container}>
      <div>
        <div className={styles.title}>
          <div>
            <Text variant="title-medium">{t('tabDocumentsInternalTitle')}</Text>
            <Text variant="text-small">
              {t('tabDocumentsInternalDescription')}
            </Text>
          </div>
        </div>

        <CardDocuments
          hasHeader={false}
          data={internalDocuments}
          isLoading={isLoading}
        />
      </div>

      <div>
        <div className={styles.title}>
          <div>
            <Text variant="title-medium">{t('tabDocumentsExternalTitle')}</Text>
            <Text variant="text-small">
              {t('tabDocumentsExternalDescription')}
            </Text>
          </div>
          <Button
            className={styles['add-button']}
            variant="ghost"
            onClick={() => setIsOpenExternalDocuments(true)}
          >
            {t('tabDocumentsExternalAddDocuments')}
            <AddCircleOutlineIcon />
          </Button>
        </div>

        <CardDocuments
          hasHeader={false}
          data={externalDocuments}
          isLoading={isLoading}
        />
      </div>

      <ExternalDocumentsDrawer
        initialValues={supplyOrder || ({} as SupplyOrderProps)}
        isOpen={isOpenExternalDocuments}
        onHandleClose={() => setIsOpenExternalDocuments(false)}
      />
    </div>
  )
}
